import React, { useEffect, useState } from "react";
import { Box, FormControl, MenuItem, Select } from "@mui/material";

const AssignUserCell = ({
  id,
  field,
  value,
  row,
  users = [],
  updateAssignedUser,
}) => {
  const rowValue = row?.[field] || value || null;
  const [currentValue, setCurrentValue] = useState(rowValue);

  useEffect(() => {
    setCurrentValue(rowValue);
  }, [rowValue]);

  const handleChange = async (event) => {
    const newValue = event.target.value;
    setCurrentValue(newValue);
    await updateAssignedUser(id, field, newValue);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        minHeight: "100%",
        py: 0.5,
      }}
    >
      <FormControl fullWidth variant="standard" size="small">
        <Select
          value={currentValue}
          onChange={handleChange}
          displayEmpty
          sx={{
            fontWeight: 600,
            color: currentValue ? "text.primary" : "text.secondary",
          }}
        >
          <MenuItem value={null}>
            <em>Select User</em>
          </MenuItem>
          <MenuItem value="NA">
            <em>N/A</em>
          </MenuItem>

          {users
            .sort((a, b) => a.user_name.localeCompare(b.user_name))
            .map((user) => {
              const userId = user.user_id || user.id || user.email || "";
              const userName =
                user.user_name ||
                `${user.first_name || ""} ${user.last_name || ""}`.trim() ||
                userId;

              return (
                <MenuItem key={userId} value={userId}>
                  {userName}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    </Box>
  );
};

export default AssignUserCell;
